import { updateKeyInStore } from 'App';
import { store } from 'app/redux/store';
import { countries } from 'countries';
import * as Yup from 'yup';
import { requiredFiles } from '../../useValidateQuestionnaire';
import {
  TaxesPaidStateValues,
  TEstimatesTaxPaymentsTableRow,
  updateFieldArrayKey,
  updateKey,
} from './slice';

export const fields: IBaseField<
  keyof TaxesPaidStateValues | keyof TEstimatesTaxPaymentsTableRow
>[] = [
  {
    name: 'didYouPayAnyUsTaxIsYear',
    label: 'Did you pay any US tax in the selected year?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'pleaseUploadCorrespondingTaxFormw210991042SEtc',
        label: 'Please upload corresponding tax form (W2, 1099, 1042-S, etc)',
        subLabel: () => <p>All US Tax Withheld has a corresponding tax form</p>,
        type: 'upload',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
    ],
  },
  {
    name: 'didYouPayAnyNonUSTaxOnYourYearEarnings',
    label:
      'Did you pay any Non-US tax on your selected year earnings (Wages, bonus)?',
    subLabel: () => (
      <p>Tax actually paid or withheld on this or prior year earnings</p>
    ),
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'didYouPayAnyNonUSTaxOnYourYearEarningsWhichYear',
        label: 'Which Country',
        type: 'country',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'amountOfNonUSTaxPaidOnAnyEarningsWagesBonusSelfemploymentIncomeAndOtherPayment',
        label:
          'Amount of non-US tax paid on any earnings (wages, bonus, self-employment income, and other payment) in {year}?',
        subLabel: () => (
          <p>Tax actually paid or withheld on this or prior year earnings</p>
        ),
        type: 'currency',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'didYouMakeContributionsToASocialSecuritySystemDuringYear',
        label:
          'Did you make contributions to a Social Security system during {year}?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'didYouMakeContributionsToASocialSecuritySystemDuringYearWhichYear',
            label: 'Which Country',
            type: 'country',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
    ],
  },
  {
    name: 'didYouMakeAnyEstimatedTaxPayments',
    label: 'Did you make any estimated tax payments?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'didYouMakeEstimatedTaxPaymentsToTheIrsOrAnyUsState',
    label: 'Did you make Estimated Tax Payments to the IRS or any US State?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'estimatesTaxPaymentsTable',
        label: 'Estimates Tax Payments table',
        type: 'fieldArray',
        tooltip: '',
        comment: true,
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        predicate: (value) => value === 'yes',
        defaultDependency: {
          year: null,
          datePaid: null,
          federalAmount: null,
          state: null,
          amount: null,
        },
        dependencies: [
          {
            name: 'year',
            label: 'Year',
            type: 'select',
            options: [
              {
                label: 'Year',
                value: 'Year',
              },
              {
                label: '2021',
                value: '2021',
              },
            ],
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'datePaid',
            label: 'Date Paid',
            type: 'date',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Select Date',
          },
          {
            name: 'federalAmount',
            label: 'Federal Amount',
            type: 'currency',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'state',
            label: 'State',
            type: 'select',
            options: [
              {
                label: 'List of states',
                value: 'List of states',
              },
            ],
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'amount',
            label: 'Amount',
            type: 'currency',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
